import { Component } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LicenseInfoComponent } from './license-info/license-info.component';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [
    MatInputModule,
    MatButtonModule,
    HttpClientModule,
    LicenseInfoComponent
  ],
  providers: [],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class SearchComponent {

}
